var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "PolarisVue-CollapseTransition",
      "enter-active-class": "PolarisVue-CollapseTransition--show",
      "leave-active-class": "PolarisVue-CollapseTransition--show",
      "enter-class": "PolarisVue-CollapseTransition--hide",
      "leave-to-class": "PolarisVue-CollapseTransition--hide"
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-99631868", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99631868","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/transitions/CollapseTransition.vue
// module id = 320
// module chunks = 0